<template>
  <with-error-message :show-error="showError"
                      :character-limit="textCountLimit"
                      :character-count="textCount"
  >
    <section-header class="w-full mt-2" title="Text" @remove-section="text = null" />
    <t-textarea v-model="text"
                class="mt-1"
                :class="textClasses"
                variant="textSection"
                @focus="handleFocus"
                @blur="handleBlur"
                ref="text"
                rows=5 />
  </with-error-message>
</template>

<script>
import { SECTION_FOCUSES } from '@/store/constants'
import contentUtils from '@/utils/content.utils'
import CharacterCounter from './CharacterCounter'
import SectionHeader from './SectionHeader'
import chatBubbleModule from '@/store/modules/chat-bubble.module'
import conversationModule from '@/store/modules/conversation.module'
import previewModule from '@/store/modules/preview.module'
import WithErrorMessage from '@/components/common/WithErrorMessage.vue'

export default {
  components: {
    CharacterCounter, SectionHeader, WithErrorMessage
  },

  watch: {
    focus:{
      immediate: true, // necessary if answer doesn't exist yet
      handler() {
        this.$nextTick(()=>{ // if answer doesn't exist the HTML is built during the current tick
          if(this.focus === SECTION_FOCUSES.TEXT) {
            this.$refs.text.focus()
          }
        })
      } }
  },

  computed: {
    actionId: chatBubbleModule.actionId,
    error: previewModule.error,
    errorDescription: previewModule.errorDescription,

    isEmptyTextError() {
      return chatBubbleModule.isErrorBubbleFocused() && (
        this.errorDescription === 'Text bubble is not allowed to be empty!' ||
        this.errorDescription === '"Text" cannot be blank.'
      )
    },

    isNonExistingVariableError() {
      return chatBubbleModule.isErrorBubbleFocused() && this.error?.section === 'text' && this.errorDescription?.startsWith('Variable')
    },

    showError() {
      return (this.isEmptyTextError && this.textCount <= this.textCountLimit) || this.isNonExistingVariableError
    },

    action() {
      return conversationModule.getAction(chatBubbleModule.bubbleSelected.stateId, this.actionId)
    },

    focus: {
      get() {
        return this.$store.state.ui.preview.bubbleSelected.sectionFocus
      },

      set(focus) {
        this.$store.commit('UI_BUBBLE_SECTION_FOCUS', focus)
      }
    },

    textClasses() {
      if (this.showError) return 'border-focus-error focus:border-focus-error'

      if (this.focus === SECTION_FOCUSES.TEXT) {
        return this.textCount > this.textCountLimit ? 'border-focus-error' : 'border-focus'
      }

      return 'border-soft'
    },

    text: {
      get() {
        return contentUtils.getText(this.action)
      },

      set(text) {
        const content = contentUtils.createContent(text, this.buttons, this.quickReplies)
        this._addAction(this.actionId, content)
        if (this.showError && text.length) this.error = null
      }
    },

    textCount() {
      return this.text.length
    },

    textCountLimit() {
      return 640
    },

    buttons() {
      return contentUtils.getButtons(this.action)
    },

    quickReplies() {
      return contentUtils.getQuickReplies(this.action)
    }
  },
  methods: {
    _addAction(actionId, content) {
      conversationModule.addOutputAction(actionId, content)
    },

    handleFocus() {
      chatBubbleModule.focusSection(SECTION_FOCUSES.TEXT)
    },

    handleBlur() {
      chatBubbleModule.focusSection(SECTION_FOCUSES.NONE)
    }
  }
}
</script>
